<div
	class="records"
	[nbSpinner]="loading"
	nbSpinnerStatus="primary"
	nbSpinnerSize="large"
>
	<h5>{{ translatedType }}</h5>
	<ng2-smart-table
		class="table"
		[settings]="smartTableSettings"
		[source]="smartTableSource"
		#recordHistoryTable
	>
	</ng2-smart-table>
</div>
